import axios from 'axios';
import store from '../../store/index';

export default {
	list(showDeleted) {
		return axios.get(`/api/admins?deleted=${showDeleted}`, {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
};
